"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Maria Sanchez",
  condition: "Full Premium Dentures",
  quote: "I can finally eat my favorite foods again without any discomfort. Smart Choice made the process so easy and affordable. My new smile has completely changed my self-esteem.",
  rating: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/patient_elena.png",
  initials: "MS"
}, {
  id: 2,
  name: "Robert Thompson",
  condition: "Dental Implant Procedure",
  quote: "The sedation made the implant surgery a breeze. I woke up and the team was already finished. My new teeth look completely natural and feel even stronger than my originals.",
  rating: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/patient_javier.png",
  initials: "RT"
}, {
  id: 3,
  name: "Linda Chen",
  condition: "Emergency Extraction",
  quote: "I came in with severe pain and left with a clear recovery plan. Their efficiency and gentle care during my extraction were truly impressive. A quality clinic I highly recommend.",
  rating: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/patient_carmen.png",
  initials: "LC"
}];
export default function Testimonials() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="167697" id="patientsuccessstories" className="py-32 bg-secondary relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-accent/10 rounded-full blur-3xl translate-y-1/3 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default tracking-tight text-foreground mb-4">
            Restoring Smiles, <span className="text-primary">Reclaiming Confidence</span>
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Join hundreds of El Monte residents who found their perfect smile with our affordable, efficient, and high-quality denture and implant solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, i) => {
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={testimonial.id} data-index={i} ref={cardRef} className={`transition-all duration-1000 ease-out delay-[${i * 150}ms] h-full ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="h-full rounded-2xl bg-card/80 backdrop-blur-md border border-border/50 shadow-xl shadow-shadow-color/5 hover:shadow-2xl hover:shadow-primary/10 transition-shadow duration-300 flex flex-col relative overflow-hidden group">
                  {}
                  <Quote className="absolute top-6 right-6 size-12 text-primary/10 rotate-12 group-hover:rotate-0 transition-transform duration-500" />
                  
                  <CardHeader className="pb-4 relative z-10">
                    <div className="flex items-center gap-4">
                      <SafeHydrate><Avatar className="size-14 border-2 border-background shadow-sm">
                        <AvatarImage src={testimonial.image} alt={testimonial.name} />
                        <AvatarFallback className="bg-primary/10 text-primary font-default font-semibold">
                          {testimonial.initials}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div>
                        <h3 className="font-default font-semibold text-foreground text-xl leading-tight">
                          {testimonial.name}
                        </h3>
                        <p className="text-sm text-primary font-medium font-sans">
                          {testimonial.condition}
                        </p>
                      </div>
                    </div>
                  </CardHeader>
                  
                  <CardContent className="flex-grow flex flex-col justify-between relative z-10">
                    <p className="text-muted-foreground leading-relaxed mb-6 italic font-sans">
                      "{testimonial.quote}"
                    </p>
                    <div className="flex items-center gap-1 mt-auto">
                      {[...Array(testimonial.rating)].map((_, starIndex) => <Star key={starIndex} className="size-5 fill-chart-3 text-chart-3" />)}
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}